import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { AdminsApiService } from '../../api';
import { LoginAlertService } from '../login-alert.service';

interface FormData {
  email: string;
}

interface RequestPasswordResetPayload {
  mail: string;
}

@Component({ templateUrl: 'password-reset.component.html' })
export class PasswordResetComponent {
  resetForm: FormGroup;

  isLoading = false;

  private formSubmitAttempt = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private adminsApi: AdminsApiService,
    private loginAlertService: LoginAlertService
  ) {
    this.resetForm = this.fb.group({
      email: ['', Validators.compose([Validators.required, Validators.email])],
    });
  }

  isInvalidEmail(field: string = 'email'): boolean {
    return !!(
      this.resetForm.get(field).invalid &&
      (this.resetForm.get(field).touched || this.formSubmitAttempt)
    );
  }

  onSubmit() {
    this.formSubmitAttempt = true;

    if (this.resetForm.invalid) {
      return;
    }

    this.isLoading = true;
    const formData: FormData = this.resetForm.value;

    const resetCallback = () => {
      this.loginAlertService.setAlert({
        type: 'success',
        message: `A reset password email will be sent to ${formData.email} if the account exists.`,
      });
      this.router.navigateByUrl('/login');
    };

    const admin: RequestPasswordResetPayload = { mail: formData.email };
    this.adminsApi
      .requestPasswordReset(admin)
      .subscribe(resetCallback, resetCallback);
  }
}
